import _jsx from '@babel/runtime/helpers/esm/jsx';
import { memo } from 'react';
import LinksSection from '@dbh/links-section';
import { ADMIN_WEBCONTROLS_REFERENCES } from '@dbh/admindev-constants';
import { makeSelectWebcontrolWithRootAndLinksByReferenceRegexString } from '@dbh/webcontrols-redux';

const makeSelectMainLpccLinks=()=>makeSelectWebcontrolWithRootAndLinksByReferenceRegexString(ADMIN_WEBCONTROLS_REFERENCES.MAIN_LPCC_LINKS);var makeSelectMainLpccLinks$1 = makeSelectMainLpccLinks;

var _LinksSection;const MainLpccLinksSection=/*#__PURE__*/memo(()=>_LinksSection||(_LinksSection=/*#__PURE__*/_jsx(LinksSection,{makeSelectWebcontrolsLinksData:makeSelectMainLpccLinks$1,useImageLazyLoading:!0})));MainLpccLinksSection.displayName="MainLpccLinksSection";

export { MainLpccLinksSection as default };
